import React, { FC } from "react";
import PageCard from "./PageCard";

interface PageLayoutProps {
  heading: string;
  desc: string;
  cardData: {
    bg: string;
    title: string;
    desc: string;
    path: string;
  }[];
}
const PageLayout: FC<PageLayoutProps> = ({ heading, desc, cardData }) => {
  return (
    <section className="relative w-full h-full ">
      <div className="w-full bg-[#F2F6F7] px-[5%]">
        <div className="pt-16 md:pt-20 pb-28 sm:pb-32 maxContainer ">
          <h2 className="mt-2 mb-5 font-bold leading-tight text-[28px] ss:text-md md:text-lg md:max-w-[599px] tracking-wide">
            {heading}
          </h2>
          <p className="md:text-[18px] text-greyText">{desc}</p>
        </div>
      </div>

      <div className="px-[5%] ">
        <div className="pb-8 md:pb-20 maxContainer ">
          <div className="relative justify-center w-full grid ss:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-8 gap-x-[3%] -top-20 ">
            {cardData.map(({ bg, title, desc, path }, idx) => (
              <PageCard
                bg={bg}
                title={title}
                desc={desc}
                key={idx}
                path={path}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageLayout;
